import { render, staticRenderFns } from "./mid_autumn.vue?vue&type=template&id=51023844&scoped=true&"
import script from "./mid_autumn.vue?vue&type=script&lang=js&"
export * from "./mid_autumn.vue?vue&type=script&lang=js&"
import style0 from "./mid_autumn.vue?vue&type=style&index=0&id=51023844&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51023844",
  null
  
)

export default component.exports